import { v4 as uuidv4 } from 'uuid';

import { createSlice } from '@reduxjs/toolkit';

import { AppThunk } from '../../../app/store';
import { automatedEvidencesEndPoint } from '../../../common/api.endPoints';
import { HttpService } from '../../../common/http.service';
import { IAutomatedEvidence } from './interfaces/IAutomatedEvidence';

export const autoEvidenceSlice = createSlice({
  name: 'autoEvidenceSlice',

  initialState: {
    automatedEvidences: [] as IAutomatedEvidence[],
  },

  reducers: {
    onAutomatedEvidenceFetchSuccess: (state, action) => {
      state.automatedEvidences = action.payload
        .response as IAutomatedEvidence[];
    },
  },
});

export const fetchAutomatedEvidences =
  (
    applicationId: string,
    setAutomatedEvidenceFetchStatus: (status: string) => void,
    openSnacks: any,
    setSnacksCallback: (updatedSnacks: any) => void,
  ): AppThunk =>
  async dispatch => {
    setAutomatedEvidenceFetchStatus('loading');
    const response = await HttpService.getInstance().get(
      automatedEvidencesEndPoint(applicationId),
    );
    if (response && !response.error) {
      const autoEvidences = response.parsedBody;
      dispatch(
        autoEvidenceActions.onAutomatedEvidenceFetchSuccess({
          response: autoEvidences,
        }),
      );
      setAutomatedEvidenceFetchStatus('success');
    } else {
      setAutomatedEvidenceFetchStatus('success');
      if (response && response.error) {
        setSnacksCallback([
          ...openSnacks,
          {
            id: uuidv4(),
            type: response.error.type,
            message: response.error.message,
          },
        ]);
      }
    }
  };

export const autoEvidenceReducer = autoEvidenceSlice.reducer;
export const autoEvidenceActions = autoEvidenceSlice.actions;
